import React, { useState, useRef } from 'react';
import { ACTIVITY_TYPES } from '../../platform/store/useOperationalStore';
import { CATEGORY_OPTIONS } from './roConstants';
import { uploadPhoto } from './roHelpers';

export default function ActivityForm({ activeType, onClose, onSubmit, disabled }) {
  const [text, setText] = useState('');
  const [category, setCategory] = useState('');
  const [customerFacing, setCustomerFacing] = useState(false);
  const [photoFile, setPhotoFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  const isTextRequired = activeType !== ACTIVITY_TYPES.PHOTO;

  async function handleSubmit() {
    if (isTextRequired && !text.trim()) return;
    setUploading(true);
    try {
      let photoKey = null;
      if (photoFile) {
        photoKey = await uploadPhoto(photoFile);
      }
      await onSubmit({
        type: activeType,
        text: text.trim(),
        category: category || null,
        customerFacing,
        photos: photoKey ? [photoKey] : [],
      });
      setText('');
      setCategory('');
      setCustomerFacing(false);
      setPhotoFile(null);
      onClose();
    } catch (err) {
      console.error('[ROPage] Activity submit error:', err);
    } finally {
      setUploading(false);
    }
  }

  const supportsCategory = [ACTIVITY_TYPES.FINDING, ACTIVITY_TYPES.REPAIR].includes(activeType);
  const supportsFacing   = [ACTIVITY_TYPES.FINDING, ACTIVITY_TYPES.REPAIR].includes(activeType);

  return (
    <div className="ro-form">
      {activeType !== ACTIVITY_TYPES.PHOTO && (
        <textarea
          className="ro-form-text"
          placeholder={
            activeType === ACTIVITY_TYPES.FINDING ? 'Describe the finding…' :
            activeType === ACTIVITY_TYPES.REPAIR   ? 'Describe the repair performed…' :
            activeType === ACTIVITY_TYPES.NOTE     ? 'Add a note…' :
            'Description…'
          }
          rows={3}
          value={text}
          onChange={e => setText(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey && activeType === ACTIVITY_TYPES.NOTE) { e.preventDefault(); handleSubmit(); } }}
          autoFocus
        />
      )}

      {supportsCategory && (
        <div className="ro-form-row">
          <select className="ro-form-select" value={category} onChange={e => setCategory(e.target.value)}>
            <option value="">Category (optional)</option>
            {CATEGORY_OPTIONS.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
          {supportsFacing && (
            <label className="ro-form-toggle">
              <input type="checkbox" checked={customerFacing} onChange={e => setCustomerFacing(e.target.checked)} />
              Customer-Facing
            </label>
          )}
        </div>
      )}

      <div className="ro-form-row">
        <button className="ro-form-photo-btn" type="button" onClick={() => fileRef.current?.click()}>
          {photoFile ? `📎 ${photoFile.name}` : '📎 Attach Photo'}
        </button>
        <input ref={fileRef} type="file" accept="image/*" capture="environment" style={{ display: 'none' }}
          onChange={e => setPhotoFile(e.target.files[0] || null)} />

        <button className="ro-form-cancel" type="button" onClick={onClose}>Cancel</button>
        <button
          className="ro-form-submit"
          type="button"
          onClick={handleSubmit}
          disabled={disabled || uploading || (isTextRequired && !text.trim())}
        >
          {uploading ? 'Saving…' : 'Save'}
        </button>
      </div>
    </div>
  );
}
